import { render, staticRenderFns } from "./ownership-activity.vue?vue&type=template&id=50a94351&scoped=true"
import script from "./ownership-activity.vue?vue&type=script&lang=js"
export * from "./ownership-activity.vue?vue&type=script&lang=js"
import style0 from "./ownership-activity.vue?vue&type=style&index=0&id=50a94351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a94351",
  null
  
)

export default component.exports